import Component from 'umg-ember-backend/components/record-explorer';

export default class RecordExplorerForLocationComponent extends Component {
  // Defaults
  defaultColumns = ['id', 'name', 'city', 'cmsState', 'cmsModified'];

  tableColumns = [
    {
      property: 'id',
      sortable: true,
    },
    {
      property: 'name',
      sortable: true,
      isMainColumn: true,
    },
    {
      property: 'city',
      sortable: true,
    },
    {
      property: 'cmsState',
      sortable: true,
      type: 'translate-value',
      align: 'right',
    },
    {
      property: 'cmsModified',
      sortable: true,
      type: 'date',
      format: 'L LT',
      align: 'right',
    },
    {
      property: 'cmsCreated',
      sortable: true,
      type: 'date',
      format: 'L LT',
      align: 'right',
    },
  ];
}
